import { QueryClient } from "@tanstack/react-query";
import { isApiError } from "./http";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry(failureCount, error) {
        if (isApiError(error) && error.status === 401) return false;
        return failureCount < 1;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
